<template>
  <layout-main-inner title="快检报告">
    <layout-card-wrap hasSlot>
      <template slot="form">
        <!-- <el-input
          v-model="config.vendorName"
          clearable
          placeholder="请输入企业名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input> -->
        <el-radio-group
          v-model="config.inspectionResults"
          @change="()=> { handleCurrentChange(1) }">
          <el-radio-button :label="null">全部</el-radio-button>
          <el-radio-button :label="[1]">合格</el-radio-button>
          <el-radio-button :label="[2,3]">不合格</el-radio-button>
        </el-radio-group>
        <product-auto-select
          v-model="config.productId"
          style="margin-left: 10px;width: 170px"
          :callback="()=> { handleCurrentChange(1) }" />
        <ent-auto-select
          v-model="config.vendorId"
          style="margin-left: 10px;width: 170px"
          :callback="()=> { handleCurrentChange(1) }" />
        <el-button
          type="primary"
          style="margin-left: 10px"
          @click="handleCurrentChange(1)"
        >查询</el-button>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="报告编号"
          width="148"
          prop="reportNo"> </el-table-column>
        <el-table-column
          label="报告名称"
          min-width="140"
          prop="reportName"></el-table-column>

        <!-- <el-table-column
          label="PDF文件"
          min-width="260"
          prop="reportPdfFile">
          <template slot-scope="{ row }">
            <el-link
              type="primary"
              style="font-size: 12px"
              :underline="false"
              :href="row.reportPdfFile"
              target="_blank"
              rel="noopener noreferrer">{{ row.reportPdfFile }}</el-link>
          </template>
        </el-table-column> -->
        <el-table-column
          label="样品名称"
          min-width="120"
          prop="productName"></el-table-column>
        <el-table-column
          label="企业名称"
          min-width="170"
          prop="vendorName"></el-table-column>
        <el-table-column
          label="检测机构"
          min-width="130"
          prop="sgsName"></el-table-column>
        <el-table-column
          label="检测人员"
          min-width="120"
          prop="inspector"></el-table-column>
        <el-table-column
          label="报告图片"
          width="95"
          prop="reportImageFile">
          <template slot-scope="{ row }">
            <el-image
              v-if="row.reportImageFile"
              style="width: 70px; height: 98.7px"
              :src="row.reportImageFile"
              :preview-src-list="[row.reportImageFile]">
            </el-image>
            <span v-else>报告生成中</span>
          </template>
        </el-table-column>
        <el-table-column
          label="判定结果"
          width="100"
          prop="createdTime">
          <template slot-scope="{ row }">
            <template v-if="row.reportImageFile">
              <span
                v-if="row.unQualifiedInspectionDataItemCount === 0"
                style="color:#67c23a">合格</span>
              <span
                v-if="row.unQualifiedInspectionDataItemCount > 0"
                style="color:red">{{ row.unQualifiedInspectionDataItemCount }}项不合格</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          label="生成时间"
          min-width="135"
          prop="createdTime">
          <template slot-scope="{ row }">
            {{ row.createdTime | dateformat() }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          :width="permission.LAB ? 150 : 80">
          <template slot-scope="{ row }">
            <el-button
              v-if="permission.LAB"
              type="danger"
              @click="deleteitem(row)">
              撤销
            </el-button>
            <el-button
              v-if="row.reportImageFile"
              type="primary"
              @click="downloaditem(row)">
              下载
            </el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column
          v-if="permission.OPERATE"
          label="机构"
          prop="seaportName"
          width="120"
        >
        </el-table-column>
        <el-table-column
          label="监管员"
          prop="supervisorName"
          width="120">
        </el-table-column>
        <el-table-column
          label="备案日期"
          width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime | dateformat() }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          v-if="permission.OPERATE || permission.AGENCY_ADMIN"
          label="操作"
          width="180"
        >
          <template slot-scope="{ row }">
            <el-button
              v-if="permission.OPERATE"
              type="primary"
              @click="updateitem(row)"
            >
              编辑
            </el-button>
            <el-button
              type="primary"
              @click="setvendorsupervisor(row)">
              设置监管员
            </el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </layout-card-wrap>
    <el-link
      ref="link"
      type="primary"
      style="display: none;"
      :underline="false"
      :href="reportPdfFile"
      target="_blank"
      rel="noopener noreferrer"></el-link>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import EntAutoSelect from '../../components/ent-auto-select.vue'
import ProductAutoSelect from '../../components/product-auto-select.vue'

export default {
  name: 'InspectionReport',
  components: { EntAutoSelect, ProductAutoSelect },
  data() {
    return {
      loading: true,
      list: [],
      totalNum: 0,
      reportPdfFile: null,
      config: {
        pageNum: 1,
        pageSize: 10,
        sgsId: null,
        vendorId: null,
        productId: null,
        beginTime: null,
        endTime: null,
        inspectionResults: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getinspectionreports', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    downloaditem(row) {
      this.reportPdfFile = row.reportPdfFile
      this.$refs.link.$el.click()
    },
    deleteitem(row) {
      this.$confirm('此操作将永久删除该报告, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/deleteinspectionreport', {
          payload: {
            inspectionReportId: row.inspectionReportId
          },
          success: () => {
            this.loading = false
            this.handleCurrentChange(1)
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    }
  }
}
</script>
